/**
 * Primary UI font: Inter via `next/font/local` (`feagiUiFont` in layout.tsx).
 * CSS variable is injected on `<html>`; fallbacks match feagi-desktop.
 */
export const FEAGI_UI_FONT_FAMILY =
  'var(--font-feagi-ui), "Helvetica Neue", Helvetica, Arial, sans-serif';
